import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const CountyApi = createApi({
  reducerPath: "CountyApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_BASE_URL}/api/property`,
    prepareHeaders: (headers, { getState }) => {
      const { accessToken } = getState().user.tokens;

      if (accessToken) {
        headers.set("authorization", `Bearer ${accessToken}`);
      }

      headers.set("x-api-key", process.env.REACT_APP_SERVER_API_KEY);
      headers.set("Content-Type", "application/json");

      return headers;
    },
  }),
  endpoints: (build) => ({
    getCountyDetailsByStateAndCounty: build.query({
      query: ({ stateCode, countyName }) => ({
        url: `/countydetailinformation`,
        method: "POST",
        body: {
          stateName: stateCode,
          countyName,
        },
      }),
    }),
    getCountySales: build.query({
      query: ({ stateCode, countyName }) => ({
        url: `/countysalesinformation`,
        method: "POST",
        body: {
          stateName: stateCode,
          countyName,
        },
      }),
    }),
    getCountiesByState: build.query({
      query: ({ stateCode }) => ({
        url: `/countylistbystate`,
        method: "GET",
        params: { stateCode },
      }),
    }),
  }),
});

export const { useGetCountyDetailsByStateAndCountyQuery, useGetCountySalesQuery, useGetCountiesByStateQuery } = CountyApi;